import React from 'react';
import useLocationKey from '../hooks/useLocationKey';
import { root } from '../constants';

const _root = root || '/';

const LocationRoute = (Com: any): any => function LocationCom(props: any) {
  const locationKey = useLocationKey();
  const isRoot = props.match?.url === _root;
  const isThemePage = props.type === 'THEME_PAGE';
  if (isRoot || isThemePage) {
    // 跟目录下面调用pageview或者特色主题调用的pageview不触发重载
    return <Com weId={`${props.weId || ''}_nnbdf7`} {...props} />;
  }
  return <Com weId={`${props.weId || ''}_nnbdf7`} key={locationKey} {...props} />;
};

export default LocationRoute;
